<label class="st-field-label">{{ label }}</label>
<input [id]="idVal" class="form-control st-input-text-field" [placeholder]="placeHolderVal" type="text"
       maxLength="20"
       pattern="[0-9]"
       [ngStyle]="{
          'width': width
       }"
       [value]="inputVal"
       [required]="requiredVal"
       [maxLength]="maxLength"
>
